import { render, staticRenderFns } from "./BarLoader.vue?vue&type=template&id=0f0cb424&scoped=true"
import script from "./BarLoader.vue?vue&type=script&lang=js"
export * from "./BarLoader.vue?vue&type=script&lang=js"
import style0 from "./BarLoader.vue?vue&type=style&index=0&id=0f0cb424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0cb424",
  null
  
)

export default component.exports